const getTextMatchArray = (text: string, match: string) => {
  if (!match || !text) return [{ text, match: false }]
  const re = new RegExp(match, 'gi')
  const matches = text.match(re)
  const output = []
  let remaining = text as any
  while (matches && matches.length) {
    let array = remaining.split(matches[0])
    while (array.length) {
      if (array.length === 1) {
        remaining = array.pop()
        matches.shift()
        break
      }
      const next = array.shift()
      if (next) output.push({ text: next, match: false })
      output.push({ text: matches[0], match: true })
    }
  }
  output.push({ text: remaining, match: false })
  return output
}

export default getTextMatchArray
